import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=0c5e75bc&scoped=true"
import script from "./FormRender.vue?vue&type=script&lang=js"
export * from "./FormRender.vue?vue&type=script&lang=js"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=0c5e75bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e75bc",
  null
  
)

export default component.exports